<template>
  <div class="nx-searcher-filter-radios">
    <v-radio-group :value="value" :input-value="value" @change="updateFilter" :disabled="disabled">
      <v-radio v-for="item in options" :key="item"
               :label="$t('message.searcher.filters.values.' + filter + '.' + item)"
               :disabled="disabled"
               :value="item"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import Filter from './Filter';

export default {
  name: 'nx-searcher-filter-radios',
  extends: Filter,
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-searcher-filter-radios {
  .v-input__slot {
    margin-bottom: 0
  }
  .v-messages {
    display: none;
  }
}
</style>
